var deps = ['Utils'];
function columnJoinCtrl(Utils) {
  function controller() {
    var ColumnJoinCtrl = this;
    var layouts = {
      joined: {
        normal: [{
          type: 'STATEMENT_PROPERTY',
          statementProperty: 'actors.person.id+object.id'
        }],
        reverse: [{
          type: 'STATEMENT_PROPERTY',
          statementProperty: 'object.id+actors.person.id'
        }]
      },
      split: {
        normal: [{
          type: 'STATEMENT_PROPERTY',
          statementProperty: 'actors.person.id'
        }, {
          type: 'STATEMENT_PROPERTY',
          statementProperty: 'object.id'
        }],
        reverse: [{
          type: 'STATEMENT_PROPERTY',
          statementProperty: 'object.id'
        }, {
          type: 'STATEMENT_PROPERTY',
          statementProperty: 'actors.person.id'
        }]
      }
    };
    function splitColumns() {
      ColumnJoinCtrl.workingConfig.dimensions = isReversed() ? layouts.split.reverse : layouts.split.normal;
      ColumnJoinCtrl.onChanges();
    }
    function joinColumns() {
      ColumnJoinCtrl.workingConfig.dimensions = isReversed() ? layouts.joined.reverse : layouts.joined.normal;
      ColumnJoinCtrl.onChanges();
    }
    function isSplitColumn() {
      return ColumnJoinCtrl.workingConfig.dimensions.length > 1;
    }
    function isReversed() {
      return Utils._try(function () {
        if (isSplitColumn()) {
          return ColumnJoinCtrl.workingConfig.dimensions[0].statementProperty === 'object.id';
        } else {
          return ColumnJoinCtrl.workingConfig.dimensions[0].statementProperty.split('+')[0] === 'object.id';
        }
      }, false);
    }
    ColumnJoinCtrl.splitColumns = splitColumns;
    ColumnJoinCtrl.joinColumns = joinColumns;
  }
  return {
    templateUrl: "modules/common/directives/dropdown/column-join-ctrl.html",
    controller: controller,
    controllerAs: 'CompoundDimCtrl',
    restrict: 'E',
    bindToController: true,
    scope: {
      workingConfig: '<',
      onChanges: '&'
    }
  };
}
angular.module('wsLrs.directives').directive('columnJoinCtrl', [].concat(deps, [columnJoinCtrl]));
